import { SectionHeading } from '@/components/ui'

interface PlaceholderSectionProps {
  title: string
}

export function PlaceholderSection({ title }: PlaceholderSectionProps) {
  return <SectionHeading title={title} description="Coming soon" />
}
